import { Agency } from "@adgate/common/types/agency.type";
import { CommercialOffice } from "@adgate/common/types/commercial-office.type";
import { Status } from "@adgate/common/types/status.type";
import { BaseObject } from "@adgate/common/types/base-object.type";

export class CreativityFilter
{
    id!: number | null;
    orderId!: number | null;
    referenceCode: string | null = null;
    brand: string | null = null;
    campaignTitle!: string | null;
    originalFilename!: string | null;
    createdFrom: number | null = null;
    createdTo: number | null = null;
    orderStatus: BaseObject | null = null;
    commercialOffice: BaseObject[] | null = null;
    agency: BaseObject[] | null = null;
    status: BaseObject[] | null = null;
    limit: number = 100;
}
